import { pgEnum } from "drizzle-orm/pg-core";

export const visibility = pgEnum("visibility", ["public", "private"]);
export const discoverability = pgEnum("discoverability", ["listed", "unlisted"]);

export const timePrecision = pgEnum("time_precision", ["date", "datetime"]);
